var map = {
	"./Ko-fi_Logo_RGB.png": "b148",
	"./bch.png": "502e",
	"./btc.png": "c0b3",
	"./paymaya.png": "05ad",
	"./paypal.png": "dedf",
	"./xrp.png": "af0e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";